<template>
  <div id="whatsapp-dashboard">
    <h3>WhatsApp</h3>
    <!-- subscription cancellation for location -->
    <div class="row">
      <div class="outer-box" >
        <h4>Cancel Subscription for location</h4>
        <div class="inner-box" style="text-align: left; width: 500px;">
          <div>Location Id</div>
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Location Id"
            v-model="subscription.locationId"
          />
          <br />
          <br />
          <button :disabled="subscription.processing" class="btn btn-primary mt-4" @click="cancelLocationWhatsappSubscription">
            <moon-loader v-if="subscription.processing" :loading="true" size="21px" color="#fafafa" />
            <span v-else>Cancel subscription</span>
          </button>
          <pre v-if="subscription.response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{subscription.response}}</pre>
        </div>
      </div>
    </div>
    <!-- remove whatsapp integration for location -->
    <div class="row">
      <div class="outer-box" >
        <h4>Disconnect WABA integration for location</h4>
        <div class="inner-box" style="text-align: left; width: 500px;">
          <div>Location Id</div>
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Location Id"
            v-model="integration.locationId"
          />
          <br />
          <br />
          <button :disabled="integration.processing" class="btn btn-primary mt-4" @click="disconnectLocationWhatsappIntegration">
            <moon-loader v-if="integration.processing" :loading="true" size="21px" color="#fafafa" />
            <span v-else>Disconnect Integration</span>
          </button>
          <pre v-if="integration.response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{integration.response}}</pre>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      subscription: {
        locationId: '',
        processing: false,
        response: null
      },
      integration: {
        locationId: '',
        processing: false,
        response: null
      },
    };
  },
  methods: {
    async cancelLocationWhatsappSubscription() {
      try {
        this.subscription.processing = true;
        this.subscription.response = (await SaasService.disableWhatsappForLocation(this.subscription.locationId)).data
      }
      catch (err) {
        this.subscription.response = err.response.data
      }
      finally {
        this.subscription.processing = false;
      }
    },
    async disconnectLocationWhatsappIntegration() {
      try {
        this.integration.processing = true;
        this.integration.response = (await SaasService.disconnectWhatsappIntegrationForLocation(this.integration.locationId)).data?.message
      } catch (err) {
        this.integration.response = err.response.data
      }
      finally {
        this.integration.processing = false;
      }
    }
  }
}
</script>
<style></style>
